/**
 * Hook to consume GameStateContext. Lives in a separate file so GameStateContext.tsx
 * only exports React components and remains eligible for Fast Refresh.
 */

import { useContext } from 'react';
import { GameStateContext } from './GameStateContext';
import type { UseGameStateReturn } from './GameStateContext';

export function useGameStateContext(): UseGameStateReturn {
    const ctx = useContext(GameStateContext);
    if (!ctx) {
        throw new Error('useGameStateContext must be used within a GameStateProvider');
    }
    return ctx;
}
